import { createContext, useContext, useState, useCallback } from "react";

const QuoteContext = createContext(null);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState("website");

  const openQuote = useCallback((src = "website") => {
    setSource(src);
    setOpen(true);
  }, []);

  return (
    <QuoteContext.Provider value={{ open, setOpen, openQuote, source }}>
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuote = () => {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error("useQuote must be used within QuoteProvider");
  return ctx;
};
